module.exports = __webpack_public_path__ + "static/media/Ranking-Camiseta-Dark.e37cc37d.png";